import React from 'react'
import style from './card.module.css'

function Arpit() {
  return (
    <div className = {style.sumit}>
        <img src='https://edge.uacdn.net/static/thumbnail/user/78c87dfb28de4172ba5fbe0e97bbf2fe.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
            <h1>Arpit Chaudhry</h1> 
            <p>Mentor for defence aspirants YouTube
                Channel with 250000 subscibers
                Recommended 3 times  
            </p> 
            <p>Teaches Mathematics and 65 more</p>  
        </div> 
    </div>
  )
}

export default Arpit